var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 40 40",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    viewBox: "0 0 40 40",
    fill: "white",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "white",
    fill: "white",
    d: "M15.3,30.9C6.8,30.9-0.1,24-0.1,15.5S6.8,0,15.3,0S30.8,7,30.8,15.5c0,1.2-0.1,2.4-0.4,3.6c-0.1,0.5-0.7,0.9-1.2,0.7   c-0.5-0.1-0.9-0.7-0.7-1.2c0.2-1,0.4-2,0.4-3.1c0-7.4-6-13.5-13.5-13.5S1.9,8.1,1.9,15.5s6,13.5,13.5,13.5c1.1,0,2.1-0.1,3.2-0.4   c0.5-0.1,1.1,0.2,1.2,0.7c0.1,0.5-0.2,1.1-0.7,1.2C17.8,30.8,16.6,30.9,15.3,30.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "white",
    fill: "white",
    d: "M36.4,40c-0.9,0-1.8-0.4-2.5-1l-11-11c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l11,11c0.6,0.6,1.6,0.6,2.1,0   c0.6-0.6,0.6-1.6,0-2.1l-11-11c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l11,11c1.4,1.4,1.4,3.6,0,5C38.2,39.6,37.3,40,36.4,40z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.3,27C9,27,3.8,21.8,3.8,15.5S9,4,15.3,4s11.5,5.2,11.5,11.5S21.7,27,15.3,27z M15.3,6c-5.2,0-9.5,4.3-9.5,9.5   s4.3,9.5,9.5,9.5s9.5-4.3,9.5-9.5S20.6,6,15.3,6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFind);
export default __webpack_public_path__ + "static/media/find.66a58b2993c0cab4660379faaa667949.svg";
export { ForwardRef as ReactComponent };